import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "./commonSlice";
import { getLocalData } from "../constant/utils/commonUtils";
import { supabase } from "../config/supabaseClient";
import moment from "moment";
import { roleType, statuses } from "../constant/constants";

export const fetchReviewData = createAsyncThunk(
  "employees/fetchReviewData",
  async ({departmentId , viewAll = false, statusFilter = null}, { rejectWithValue, dispatch }) => {
    try {
      

      dispatch(startLoading());
      const {company_id, emp_id, role} = getLocalData();

      const { data: employeeData, error: employeeError } = await supabase.rpc(
        "get_users_with_training_and_manager",
        {
          companyid: company_id,
          departmentid: departmentId,
          empid: role == roleType.MANAGER ? emp_id : null,
          viewall: viewAll,
          statusfilter: statusFilter  // Optional: filter by status (null = all statuses)
        }
      );

      if (employeeError) {
        throw employeeError;
      }

      const formattedData = employeeData?.map((employee) => {
        // Flatten selected trainings with their IDs
        const allSelectedTrainings = employee?.skills?.flatMap((skill) => {
          return (
            skill.selectedTrainings?.map((training) => ({
              id:
                training.id ||
                training.selected_training_id ||
                training.selectedTrainingId ||
                null,
              name: training.training_name || training.name || "",
              // Use allocated values from allocate_training_program if available, otherwise fallback to other sources
              training_type:
                training.allocated_training_type ||
                skill.training_type ||
                training.training_type ||
                null,
              training_category:
                training.allocated_training_category ||
                training.training_category ||
                null,
              // Cost from training catalogue (company or iFundi) so "How Much will this Training Cost?" is not 0
              cost: training.cost != null ? Number(training.cost) : 0,
              // Additional allocated fields from allocate_training_program (jsonb)
              allocated_additional_field:
                training.allocated_additional_field || null,
              completion_date: training.completion_date || "-",
            })) || []
          );
        }) || [];

        return {
          ...employee,
          status: employee.status ?? employee.Status,
          // Department is now included directly from the database function
          department: employee.department || "-",
          skills: (employee?.skills ?? []).map((skill) => {
            return {name :skill.skills_required || "", priorityLevel: skill.priority_level || ""};
          }),
          "Training Name": allSelectedTrainings.map(t => t.name),
          "Training Date": allSelectedTrainings.map(t => t.completion_date),
          "Training Type": allSelectedTrainings.map(t => t.training_type),
          selectedTrainings: allSelectedTrainings, // Include full training objects with IDs
        };
      });

      return {formattedData, departmentId};
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const fetchDepartmentHierarchyData = createAsyncThunk(
  "employees/fetchDepartmentHierarchyData",
  async ({ companyId, empId }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoading());
      // if (getLocalData().role != roleType.SDF) return null;
      
      // Return null if empId is not provided
      if (!empId) {
        return null;
      }
      
      const { data, error } = await supabase
        .from("organograms")
        .select("*")
        .eq("company_id", companyId)
        .eq("dept_head_id", empId)
        .eq("status", statuses.ACTIVE)
        .maybeSingle(); // Use maybeSingle() instead of single() to handle 0 rows gracefully
      
      if (error) throw error;

      return data?.dept_id || null;
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);
const trainingFormReviewSlice = createSlice({
  name: "trainingFormReview",
  initialState: {
    reviewFormData: [],
    loading: false,
    error: null,
    selectedDepartment: null,
  },
  reducers: {
    addSelectedDepartment: (state, action) => {
      state.selectedDepartment = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchReviewData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchReviewData.fulfilled, (state, action) => {
      state.loading = false;
      state.reviewFormData = action.payload.formattedData;
      // Only set selectedDepartment if not viewing all departments
      if (!action.meta.arg.viewAll) {
        state.selectedDepartment = action.payload.departmentId;
      } else {
        state.selectedDepartment = null;
      }
    });
    builder.addCase(fetchReviewData.rejected, (state, action) => {
      state.error = action.payload;
    });
    builder.addCase(fetchDepartmentHierarchyData.rejected, (state, action) => {
      state.error = action.payload;
    });
  },
});

export const { addSelectedDepartment } = trainingFormReviewSlice.actions;

export default trainingFormReviewSlice.reducer;
